import { useState} from 'react';
import pharmacy from 'services/pharmacy';
import { useDispatch } from 'react-redux';
import { SET_ERROR_MESSAGE } from 'helpers/types';
import { browserHistory } from 'App';

export default () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const getMedicationInfo = async (payload) => {
    try {
      setLoading(true)
      const response = await pharmacy.post(`/medication/info`, payload);
      const {data} = response;
      setLoading(false)
      return {
        fridgeline: data?.some((med) => med?.requires_refrigeration), 
        controlled: data?.some((med) => med?.recommend_collection_controlled_drug)
      }
    } catch (err) {
      if (err.response && err.response.data.readable_error_message) {
        console.error(err);
        dispatch({
          type: SET_ERROR_MESSAGE,
          payload: {
            msg: err.response.data.readable_error_message,
            newMessage: true,
            link: '',
            ctaText: '',
          },
        });
        setLoading(false)
        browserHistory.push('/pharmacy/error');
      }
      throw err;
    }
  };
  
  return [loading, getMedicationInfo];
};
